import { useEffect, useRef, useState } from 'react';
import './broadcasterModule.css'; 

export function DiffusionObligationsComponent({ data, onRuleClick, selectedRuleId, selectedYear }) {

    const contentRef = useRef(null);
    const [displayData, setDisplayData] = useState([]);

    useEffect(() => {
        if (data) {
            setDisplayData(data);
        }
    }, [data]);

    const getActiveValue = (rule) => {
        if (!rule.application_periods) return null;
        const activePeriod = rule.application_periods.find(p => 
            selectedYear >= p.start_year && (!p.end_year || selectedYear <= p.end_year)
        );
        return activePeriod ? activePeriod.value : null;
    };

    return (
        <div className="diffusion-container module-section">
            <div className="module-section-title">Obligations de diffusion</div>
            <div ref={contentRef} style={{ width: '100%', height: '100%' }}>
                <ul className="diffusion-obligations-list">
                    {displayData.map((rule, index) => {
                        const activeValue = getActiveValue(rule);
                        
                        // Si la règle a une valeur valide pour cette année, on l'affiche
                        if (activeValue) {
                            const isSelected = selectedRuleId && rule.id === selectedRuleId;
                            
                            return (
                                <li 
                                    key={index} 
                                    className="diffusion-obligations-item"
                                    style={{ 
                                        cursor: onRuleClick ? 'pointer' : 'default',
                                        transition: 'background-color 0.2s',
                                        padding: '2px 5px',
                                        borderRadius: '4px',
                                        backgroundColor: isSelected ? '#fde68a' : 'transparent' 
                                    }}
                                    onClick={(e) => {
                                        if (onRuleClick) {
                                            onRuleClick(rule);
                                            e.stopPropagation();
                                        }
                                    }}
                                    onMouseOver={(e) => { 
                                        if(onRuleClick && !isSelected) e.currentTarget.style.backgroundColor = '#f0f0f0'; 
                                    }}
                                    onMouseOut={(e) => { 
                                        if(onRuleClick && !isSelected) e.currentTarget.style.backgroundColor = 'transparent'; 
                                    }}
                                >
                                    &bull; {activeValue}
                                </li>
                            );
                        }
                        return null;
                    })}
                </ul>
            </div>
        </div>
    );
};